// This file is generated.
export const version = '1.82.0'
